export default __webpack_public_path__ + "static/media/cyberedge.7b3e51f3.png";